
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

import * as api from "../../constant/API";
import Utils from "../../constant/Utils";
import { Button } from "react-bootstrap";
import AddStudent from "./addStudent";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const Students = () => {
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [instituteId, setInstituteId] = useState("");
    const [instituteList, setInstituteList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [billingList, setBillingList] = useState([]);
    const [progs, setProgs] = useState([]);
    const [stud, setStud] = useState<any[]>([]);
    const [students, setStudents] = useState([]);

    const [addStudModal, setAddStudModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState<any>(null);

    const formRef = useRef(null);

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        institutesList();
        sportsList();
        progList();
        billingTypLst();
    }, []);

    function institutesList() {
        const instList = api.InstDd + '/' + roleId;//?userId=' + userId + '&roleId=' + roleId;
        setIsLoading(true);
        setTimeout(() => {
            fetch(instList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    setInstituteList(result.data);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                });
        }, 1500);
    }

    function listStudents(insId, usr = null) {
        setInstituteId(insId);
        let getStudList;
        if (usr != null && typeof usr != "undefined") {
            getStudList = api.StudentsList + '/' + insId + '/' + usr;
        } else {
            getStudList = api.StudentsList + '/' + insId;
        }
        fetch(getStudList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (usr != null && typeof usr != "undefined") {
                    setIsEdit(true)
                    handleOpenModal(result.data)
                }
                else {
                    if (result.error == false) {
                        setStud(result.data);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        Swal.fire(result.message);
                    }
                }
            })
    }

    function sportsList() {
        const sportsFetch = api.InventorySportList;
        fetch(sportsFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setSportList(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    function progList() {
        const getProgs = api.ProgramsList;
        fetch(getProgs, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setProgs(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    function billingTypLst() {
        const getLst = api.BillingTypeList;
        fetch(getLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setBillingList(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    function editStud(stud) {
        const usrId = stud.coreUserId;
        const usrInstitute = stud.coreUserInstituteId;
        // const studDet = api.StudentsList;
        listStudents(usrInstitute, usrId)
    }

    const filteredData = stud.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editStud(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.coreUserName}</span>;
    };

    const emailRender = (rowData) => {
        return <span>{rowData.coreUserEmail}</span>;
    };

    const phoneRender = (rowData) => {
        return <span>{rowData.coreUserPhone}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.SportName}</span>;
    };

    const classRender = (rowData) => {
        return <span>{rowData.ClassName}</span>;
    };

    const sectionRender = (rowData) => {
        return <span>{rowData.SectionName}</span>;
    };

    const handleOpenModal = (student = null) => {
        setIsEdit(!!student);
        setSelectedStudent(student);
        setAddStudModal(true);
    };

    const handleSaveStudent = (newStudent: any) => {
        const newStudentData = { ...newStudent };
        if (isEdit) {
            updateStudent(newStudentData);
        } else {
            saveStudent(newStudentData);
        }
        setAddStudModal(false);
    };

    function saveStudent(studDetails) {
        // console.log(studDetails)
        const formData = new FormData();
        formData.append("studentFirstName", studDetails.firstname);
        formData.append("studentLastName", studDetails.lastname);
        formData.append("studentDOB", studDetails.dob);
        formData.append("studentGender", studDetails.gender);
        formData.append("studentParentName", studDetails.parentname);
        formData.append("studentNationality", studDetails.nationality);
        formData.append("studentHeight", studDetails.height);
        formData.append("studentWeight", studDetails.weight);
        formData.append("studentBloodGroup", studDetails.bldgrp);
        formData.append("studentAddress", studDetails.address);
        formData.append("studentState", studDetails.state);
        formData.append("studentCity", studDetails.city);
        formData.append("studentPincode", studDetails.pincode);
        formData.append("studentEmail", studDetails.email);
        formData.append("studentPhone", studDetails.phonenum);
        formData.append("studentEmergencyContact", studDetails.emrgycntctname);
        formData.append("studentEmergencyContactNo", studDetails.emrgycntctnum);
        formData.append("studentInstitution", studDetails.institute);
        formData.append("studentClass", studDetails.class);
        formData.append("studentSection", studDetails.section);
        formData.append("studentAdmissionDate", studDetails.admsndate);
        formData.append("studentAcademicYear", studDetails.academicyr);
        formData.append("studentSport", studDetails.sport);
        formData.append("studentProgram", studDetails.prog);
        formData.append("studentAchievement", studDetails.achvmnt);
        formData.append("studentUserName", studDetails.usrname);
        formData.append("studentBillingType", studDetails.billingtyp);
        formData.append("studentSlab", studDetails.slab);

        const saveStud = api.SaveStudent;

        fetch(saveStud, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((saveResponse) => saveResponse.json())
            .then((saveResult) => {
                if (saveResult.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: saveResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: saveResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function updateStudent(studDetails) {
        const formData = new FormData();

        formData.append("studentIdEdit", studDetails.userId)
        formData.append("studentFirstNameEdit", studDetails.firstname);
        formData.append("studentLastNameEdit", studDetails.lastname);
        formData.append("studentDOBEdit", studDetails.dob);
        formData.append("studentGenderEdit", studDetails.gender);
        formData.append("studentParentNameEdit", studDetails.parentname);
        formData.append("studentNationalityEdit", studDetails.nationality);
        formData.append("studentHeightEdit", studDetails.height);
        formData.append("studentWeightEdit", studDetails.weight);
        formData.append("studentBloodGroupEdit", studDetails.bldgrp);
        formData.append("studentAddressEdit", studDetails.address);
        formData.append("studentStateEdit", studDetails.state);
        formData.append("studentCityEdit", studDetails.city);
        formData.append("studentPincodeEdit", studDetails.pincode);
        formData.append("studentEmailEdit", studDetails.email);
        formData.append("studentPhoneEdit", studDetails.phonenum);
        formData.append("studentEmergencyContactEdit", studDetails.emrgycntctname);
        formData.append("studentEmergencyContactNoEdit", studDetails.emrgycntctnum);
        formData.append("studentInstitutionEdit", studDetails.institute);
        formData.append("studentClassEdit", studDetails.class);
        formData.append("studentSectionEdit", studDetails.section);
        formData.append("studentAdmissionDateEdit", studDetails.admsndate);
        formData.append("studentAcademicYearEdit", studDetails.academicyr);
        formData.append("studentSportEdit", studDetails.sport);
        formData.append("studentProgramEdit", studDetails.prog);
        formData.append("studentAchievementEdit", studDetails.achvmnt);
        formData.append("studentUserNameEdit", studDetails.usrname);
        formData.append("studentBillingTypeEdit", studDetails.billingtyp);
        formData.append("studentSlabEdit", studDetails.slab);
        formData.append("studentStatusEdit", studDetails.status);

        const updtStud = api.UpdateStudent;

        fetch(updtStud, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((saveResponse) => saveResponse.json())
            .then((saveResult) => {
                if (saveResult.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: saveResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: saveResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }
    return (
        <>

            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        <div className="row col-md-6 court-sortby sortbyset">
                                            <div className="col-md-3">
                                                <span className="sortbytitle"><h6>Institute</h6></span>
                                            </div>
                                            <div className="col-md-9 col-sm-6 sorting-select">
                                                <Select
                                                    value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                        value: instituteId,
                                                        label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                    } : null}
                                                    onChange={(e) => {
                                                        listStudents(e.value);
                                                    }}
                                                    placeholder="Select Institute"
                                                    options={instituteList.map(ins => ({
                                                        value: ins.institutionId,
                                                        label: ins.institutionName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        {(roleId == '1' || roleId == '5') ? (
                                            <>
                                                <div className="row col-md-6">
                                                    <div className="save-changes text-sm-end">
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => handleOpenModal()}
                                                        >
                                                            <i className="fas fa-plus">Add Student</i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="coreUserName"
                                                    header="Student &nbsp; Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="coreUserEmail"
                                                    header="Student &nbsp; Email"
                                                    body={emailRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="coreUserPhone"
                                                    header="Student &nbsp; Phone"
                                                    body={phoneRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="SportName"
                                                    header="Sport"
                                                    body={sportRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="ClassName"
                                                    header="Class"
                                                    body={classRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="SectionName"
                                                    header="Section"
                                                    body={sectionRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {(roleId == '1'|| roleId == '5') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Add Student */}

            <AddStudent
                show={addStudModal}
                onHide={() => setAddStudModal(false)}
                isEdit={isEdit}
                studentData={selectedStudent}
                onSave={handleSaveStudent}
                insDet={instituteList}
                sprtDet={sportList}
                progDet={progs}
                billDet={billingList}
                validate={formRef}
            />

            {/* /Add Student */}
        </>
    );
};

export default Students;
